import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, shareReplay, switchMap } from "rxjs";
import { environment } from "../../environments/environment";
import { BaseService } from "./base.service";
import { FilterChip } from "../models/filter-chip";
import { Group, GroupMembership } from "../models/group";
import { User } from "../models/user";
import { Project, ProjectMembership } from "../models/project";

@Injectable({ providedIn: 'root' })
export class ProjectMembersService extends BaseService {
    private groupsSubject = new BehaviorSubject<GroupMembership[]>([]);
    groups$ = this.groupsSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    addProjectMemberships(project: Project, users: User[]) {
        let memberships = users.map(u => <ProjectMembership>{ projectId: project.id, userId: u.id});
        this.http.post(environment.apiUrl + `projects/${project.id}/membership`, memberships).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    deleteProjectMembership(projectId: number, userId: number) {
        this.http.delete(environment.apiUrl + `projects/${projectId}/users/${userId}`).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }
}